import React from 'react';

const DEFAULT_LABELS: any = {
    'Scouted Location': 'Scouted Location',
    'Research': 'Research',
    'Studio Vault': 'Studio Vault',
    '6th Degree Location': '6th Degree Location',
};

const LocationTag = ({ variant = 'scouted', label, className = '' }: any) => {

    return (
        <span className={`tag tag--bgcolor ${className}`}>
            {label || DEFAULT_LABELS[variant] || label}
        </span>
    )
};

export default LocationTag;